/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 07:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Page, Card } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import { URL } from 'src/constants/links';
import TitleHelp from 'src/components/views/common/title-help';
import ClockImg from 'src/assets/images/third-party-integration/clock.svg';

type Props = {
  i18n: any
};

type State = {};

type ComposedProps = Props & WithI18nProps;

class ThirdPartyIntegraion extends Component<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-Page BC-Page__ThirdPartyIntegration">
        <MainMenu menuId="menu-integration-third-party" />
        <Page title={i18n.translate('AdminHTML.ThirdPartyIntegration.title')}>
          <TitleHelp i18n={i18n} hrefUserManual={URL['Link_V2_Tool_Integration_ManualGuide']} />
          <div className="third-party-wrapper">
            <Card>
              <div className="comming-soon">
                <div className="content">
                  <img src={ClockImg} alt="clock" width={120} height={120} />
                  <span className="title">
                    {i18n.translate('AdminHTML.Common.Common.commingSoon')}
                  </span>
                  <span className="description">
                    {i18n.translate('AdminHTML.ThirdPartyIntegration.commingSoonText')}
                  </span>
                </div>
              </div>
            </Card>
          </div>
        </Page>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {};

const mapDispatchToProps = (dispatch, props) => ({});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ThirdPartyIntegraion));
